import { isEmpty } from 'lodash';

export function SiteValido(site: string): boolean {
    if (isEmpty(site)) return true;
    return /^((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/.test(site);
}